var GoSquared = {}
GoSquared.acct = 'GSN-366215-M'
;(function (w) {
  function gs() {
    w._gstc_lt = +new Date()
    var d = document,
      g = d.createElement('script')
    g.type = 'text/javascript'
    g.src = '//d1l6p2sc9645hc.cloudfront.net/tracker.js'
    var s = d.getElementsByTagName('script')[0]
    s.parentNode.insertBefore(g, s)
  }
  w.addEventListener ? w.addEventListener('load', gs, false) : w.attachEvent('onload', gs)
})(window)
